import styled from 'styled-components';
import { PromocodeProps } from '.';
import noPromoImg from './img/noPromocodeBackground.png';
import promoImg from './img/promocodeBackground.png';

export const Container = styled.div<Pick<PromocodeProps, 'noPromocode'>>`
	height: 56px;
	width: 100%;
	background-repeat: no-repeat, repeat;
	background-size: 100% 100%;
	background-position: center;
	padding: 0 30px 0 10px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	transition: all 0.3s ease-in-out;
	background-image: ${({ noPromocode }) =>
		noPromocode ? `url(${noPromoImg as string})` : `url(${promoImg as string})`};
`;

export const PromocodeText = styled.span<Pick<PromocodeProps, 'noPromocode'>>`
	font-weight: ${({ noPromocode }) => (noPromocode ? 500 : 400)};
	font-size: ${({ noPromocode }) => (noPromocode ? 14 : 12)}px;
	line-height: 16px;
	letter-spacing: -0.41px;
	transition: color 0.3s ease-in-out;
	color: ${({ noPromocode }) => (noPromocode ? '#000000' : '#dedfff')};
`;

export const Description = styled.div`
	max-width: 65%;
`;

export const Promocode = styled.span<Pick<PromocodeProps, 'promoColor'>>`
	font-weight: 800;
	font-size: 14px;
	line-height: 16px;
	letter-spacing: -0.578824px;
	color: ${({ promoColor }) => promoColor ?? '#89ffac'};
	transition: color 0.3s ease-in-out;
`;

export const DiscountContainer = styled.div<Pick<PromocodeProps, 'noPromocode' | 'promoColor'>>`
	font-size: 34px;
	line-height: 24px;
	display: flex;
	align-items: center;
	text-align: center;
	flex-direction: column;
	letter-spacing: -0.578824px;
	gap: 2px;
	font-weight: ${({ noPromocode }) => (noPromocode ? 400 : 800)};
	color: ${({ noPromocode, promoColor }) => (noPromocode ? '#000000' : promoColor ?? '#89FFAC')};
`;

export const DiscountText = styled.div<Pick<PromocodeProps, 'noPromocode' | 'promoColor'>>`
	font-weight: 500;
	font-size: 17px;
	line-height: 14px;
	color: ${({ promoColor }) => promoColor ?? '#89FFAC'};
	transition: all 0.3s ease-in-out;
`;
